import React from 'react'

// material ui
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'

// components
import Camper from './Camper'
import TransactionTotal from './TransactionTotal'
import CoppaFee from './CoppaFee'

const Summary = props => {
  const {
    account, // via withQuery
    sessions, // via withQuery
    cartForm, // via redux state
    children
  } = props

  const { campers } = account

  return (
    <Card>
      <CardContent>
        {campers.map(camper => (
          <Camper key={camper.id} camper={camper} cartForm={cartForm} account={account} />
        ))}

        <CoppaFee
          account={account}
          campers={campers}
          cartForm={cartForm}
          sessions={sessions}
        />

        <Divider />

        <TransactionTotal
          account={account}
          campers={campers}
          cartForm={cartForm}
          sessions={sessions}
        />
        {children}
      </CardContent>
    </Card>
  )
}

export default Summary
